import React from 'react';

const AjoutContractPage = () => {
  return (
    <React.Fragment>
      <h1>Ajout Contract Page</h1>
    </React.Fragment>
  );
};
export default AjoutContractPage;
